module.exports = __webpack_public_path__ + "img/1591483497.26cbd3a4.jpg";